module.exports = __webpack_public_path__ + "assets/img/reward_chair.2ea0cb0d.png";